import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.locale('es');

export default (date, format = 'D MMM YYYY') => date ?
  dayjs(date).format(format) :
  date;
